export default function Marquee({ items }) {
  const row = (ariaHidden) => (
    <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <span key={i} className="flex items-center whitespace-nowrap">
          <span className="font-display text-sm font-bold uppercase tracking-[0.22em] text-white/80">{item}</span>
          <span className="mx-8 inline-block h-2 w-2 rotate-45 bg-gold" aria-hidden="true" />
        </span>
      ))}
    </div>
  );

  return (
    <div className="overflow-hidden border-y border-white/10 bg-navy py-5 marquee-mask" data-testid="norms-marquee">
      <div className="flex w-max animate-marquee">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
